import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useHistory } from 'react-router';
import { Typography } from 'seagull';
import { routes } from '~/constants';
import { useIoContext, useOverlayContext, useStore, useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { handleRequest } from '~/infra/utils';
import { integrationModel } from '~/models';
import { EmailOnBehalfTypes } from '~/models/EmailOnBehalfSettingsModel';
import { getEmailProviderDetails, Tab } from '~/pages/NotificationSettings/NotificationSettings.utils';
import { selectors } from '~/store/state-selectors';
import outlookLogo from '../../../../assets/Outlook.png';
import IntegrationCard from '../IntegrationCard/IntegrationCard';
export default function OutlookCard(param) {
    let { integration, isDisabled } = param;
    const { t: texts } = useLocaleKeys('integrations.availableApps.outlook');
    const { t: gmailTexts } = useLocaleKeys('integrations.availableApps.gmail');
    const { t: sharedTexts } = useLocaleKeys('integrations.availableApps.shared');
    const businessId = useStore(selectors.user.businessId);
    const { api } = useStoreActions();
    const changeLocation = useIoContext().changeLocation;
    const { startLoader, stopLoader, showErrorToast } = useOverlayContext();
    const { logBI } = useStoreActions();
    const history = useHistory();
    const connect = async ()=>{
        const providerDetails = getEmailProviderDetails(EmailOnBehalfTypes.Outlook);
        if (integrationModel.isLinked(integration)) {
            history.push(routes.notifications, {
                selectedTab: Tab.Client
            });
            return;
        }
        logBI(providerDetails.biCodes.connect, {
            vendorId: businessId
        });
        if (businessId) {
            startLoader();
            const result = await handleRequest(api.notification.emailOnBehalf.connectEmailOnBehalf({
                businessId,
                provider: EmailOnBehalfTypes.Outlook,
                pageUrl: window.location.origin + window.location.pathname
            }));
            if (result.success) {
                changeLocation(result.data);
            } else {
                logBI(providerDetails.biCodes.authError, {
                    vendorId: businessId
                });
                showErrorToast(texts.failedToConnectOutlook(), "start-outlook-flow-error-toast");
            }
            stopLoader();
        } else {
            logBI(providerDetails.biCodes.authError, {
                vendorId: businessId
            });
            showErrorToast(sharedTexts.pleaseRefreshAndTryAgain(), 'no-business-id-error-toast');
        }
    };
    return /*#__PURE__*/ _jsx(IntegrationCard, {
        testId: "outlook-card",
        icon: /*#__PURE__*/ _jsx(IntegrationCard.LogoImg, {
            src: outlookLogo
        }),
        title: texts.title(),
        subTitle: texts.subTitle(),
        mainAction: /*#__PURE__*/ _jsx(IntegrationCard.MainActionButton, {
            bi: {
                name: 'connect_outlook'
            },
            onClick: connect,
            testId: "outlook-card-connect",
            disabled: isDisabled,
            tooltip: isDisabled ? {
                placement: 'right',
                title: /*#__PURE__*/ _jsxs("div", {
                    "data-testid": "outlook-card-tooltip",
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "paragraph1",
                            skin: "invertedStandard",
                            children: gmailTexts.onlyOneMailbox()
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "paragraph1",
                            skin: "invertedStandard",
                            children: texts.disconnectGmailFirst()
                        })
                    ]
                })
            } : undefined,
            children: integrationModel.isLinked(integration) ? sharedTexts.manageConnection() : sharedTexts.connectButton()
        })
    });
}
